import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import { startRedirect, validateIbackupStart } from "store/actions";
import FullPageLoader from "App/common/ui/FullPageLoader";

function Ibackup(props) {
  useEffect(() => {
    props.startRedirect(false);
    if (props.location.pathname.split("/")[3]) {
      props.validateIbackupStart(
        props.location.pathname.split("/")[3],
        props.logout,
        props.location.search.split("=")[1] === "signup" ? true : false
      );
    }

    return () => props.startRedirect(false);
  }, []);
  let content = null;

  if (props.auth.redirect) {
    content = <Redirect to="/mirror/login" />;
  } else if (
    props.auth.validateIbackup &&
    props.auth.validateIbackup.success === false
  ) {
    content = <div>{props.auth.validateIbackup.message}</div>;
  } else {
    content = <FullPageLoader />;
  }
  return content;
}

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      validateIbackupStart,
      startRedirect
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Ibackup);
